// Central company + site configuration for NBMT Trading Co.

export const COMPANY = {
  name: "NBMT Trading Co. FZE LLC",
  shortName: "NBMT",
  location: "United Arab Emirates",
  tagline: "Premium agricultural commodities, sourced with rigour and exported with care.",
  address: "Business Centre, Sharjah Publishing City Free Zone, Sharjah, United Arab Emirates",
  phone: "+92 333 817 2074",
  phoneRaw: "+923338172074",
  email: "nbmttrading@gmail.com",
  quoteContact: "nbmttrading@gmail.com",
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_global-grains-3/artifacts/83u5pojw_Image%207-24-26%20at%202.17%E2%80%AFPM.jpeg",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Global Reach", to: "/global-reach" },
  { label: "Gallery", to: "/gallery" },
  { label: "Updates", to: "/updates" },
  { label: "Catalogs", to: "/catalogs" },
  { label: "Contact", to: "/contact" },
];

export const CREDENTIALS = [
  "ISO 9001",
  "ISO 22000",
  "HACCP",
  "HALAL",
  "SGS Inspected",
  "Bureau Veritas",
];
